// extracted by mini-css-extract-plugin
module.exports = {"header":"SEUeL","logo":"AmLIX","price-container":"ijCXc","promo":"uBnFY","tip":"_4TAun","promo-clear":"-VbxH","information":"TpQ+o"};